<mat-card>
  <mat-card-content>
    <div class="flex">
      <div class="left h-100">
        <div>
          <div
            (click)="setTab('user-batch-upload')"
            [class.active]="currentTab === 'user-batch-upload'"
            class="tab"
          >
            Users
          </div>
          <div
            (click)="setTab('vehicle-batch-upload')"
            [class.active]="currentTab === 'vehicle-batch-upload'"
            class="tab"
          >
            Vehicles
          </div>
          <div
            (click)="setTab('pay-roll')"
            [class.active]="currentTab === 'pay-roll'"
            class="tab"
          >
            Pay Roll
          </div>
        </div>
      </div>

      @if (currentTab == 'user-batch-upload') {
      <div class="right">
        <app-user-batch-upload />
      </div>
      } @if (currentTab == 'vehicle-batch-upload') {
      <div class="right">
        <app-vehicle-batch-upload />
      </div>
      } @if (currentTab == 'pay-roll') {
      <div class="right">
        <app-pay-roll-batch-upload />
      </div>
      }
    </div>
  </mat-card-content>
</mat-card>
